import { useOnboardingStore } from "@/stores/onboardingStore";
import { track } from "@/utilities/analytics";
import { siteAPIURL } from "@/utilities/constants";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { Button } from "../../../../Button/Button";

interface SignUpButtonProps {
	isGas: boolean;
	signupUrl: string;
	nmi?: string;
	promoCode?: string;
	productCode?: string;
	product?: string;
}

export const SignUpButton = ({
	isGas,
	signupUrl,
	nmi,
	promoCode,
	productCode,
	product,
}: SignUpButtonProps) => {
	const [loading, setLoading] = useState(false);
	const setOnboardingData = useOnboardingStore(state => state.setOnboardingData);
	const router = useRouter();

	// if (!signupUrl) return null;

	// if loading update label
	let label = isGas ? "Apply Now" : "Sign Up Now";

	if (loading) {
		label = "Loading...";
	}

	const onSignupClick = () => {
		setLoading(true);

		// Fired before the capture request, which navigates to onboarding whether
		// it succeeds or fails — the plan is selected either way.
		track({
			event: "plan_selected",
			energy: isGas ? "gas" : "electricity",
			productCode: productCode ?? "",
			product: product ?? "",
			promo: promoCode || undefined,
		});

		fetch(siteAPIURL + `/signup/apply-capture`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				nmi,
				promoCode,
			}),
		})
			.then(response => {
				if (response.ok) {
					router.push(`/onboarding?energy=${isGas ? "gas" : "electricity"}`);
				} else {
					setLoading(false);
					console.error("Signup failed");
				}
			})
			.catch(error => {
				console.error("Signup capture failed");
				setLoading(false);
				router.push(`/onboarding?energy=${isGas ? "gas" : "electricity"}`);
			});
	};

	return (
		<div>
			<Button
				onClick={onSignupClick}
				label={label}
			/>
		</div>
	);
};
